type Props = {
  data: unknown;
};

type RenderedLine = {
  key: string;
  content: JSX.Element;
};

const renderJsonLines = (
  value: any,
  indent = 0,
  lines: RenderedLine[] = [],
  depthKey = 'root',
): RenderedLine[] => {
  const indentPx = `${indent * 16}px`;

  if (Array.isArray(value)) {
    lines.push({
      key: `${depthKey}-arr-start`,
      content: <span style={{ paddingLeft: indentPx }}>[</span>,
    });
    value.forEach((item, i) => {
      renderJsonLines(item, indent + 1, lines, `${depthKey}-${i}`);
    });
    lines.push({
      key: `${depthKey}-arr-end`,
      content: <span style={{ paddingLeft: indentPx }}>]</span>,
    });
  } else if (value && typeof value === 'object') {
    lines.push({
      key: `${depthKey}-obj-start`,
      content: <span style={{ paddingLeft: indentPx }}>{'{'}</span>,
    });
    Object.entries(value).forEach(([key, val]) => {
      if (typeof val === 'object' && val !== null) {
        lines.push({
          key: `${depthKey}-${key}`,
          content: (
            <div style={{ paddingLeft: `${(indent + 1) * 16}px` }}>
              <span className="text-red-600">"{key}"</span>:
            </div>
          ),
        });
        renderJsonLines(val, indent + 2, lines, `${depthKey}-${key}`);
      } else {
        lines.push({
          key: `${depthKey}-${key}`,
          content: (
            <div style={{ paddingLeft: `${(indent + 1) * 16}px` }}>
              <span className="text-red-600">"{key}"</span>:{' '}
              <span className="text-green-700">{JSON.stringify(val)}</span>
            </div>
          ),
        });
      }
    });
    lines.push({
      key: `${depthKey}-obj-end`,
      content: <span style={{ paddingLeft: indentPx }}>{'}'}</span>,
    });
  } else {
    lines.push({
      key: `${depthKey}-primitive`,
      content: <span style={{ paddingLeft: indentPx }}>{JSON.stringify(value)}</span>,
    });
  }

  return lines;
};

export const PrettyJsonViewer = ({ data }: Props) => {
  const lines = renderJsonLines(data);

  return (
    <div className="w-full text-sm font-mono p-4 flex gap-2 overflow-x-auto max-h-96 ">
      <div className="text-right text-foreground-subtle select-none pr-2 ">
        {lines.map((_, index) => (
          <div key={`line-num-${index}`} className="h-[20px] leading-[20px]">
            {index + 1}
          </div>
        ))}
      </div>
      <div className="flex-1 whitespace-pre break-words">
        {lines.map((line) => (
          <div key={line.key} className="h-[20px] leading-[20px]">
            {line.content}
          </div>
        ))}
      </div>
    </div>
  );
};
